import React from 'react';
import axios from 'axios';
import { BarChart, XAxis, YAxis, Bar, Tooltip, Cell, LabelList } from 'recharts';
import { Form, Header, Segment, Loader } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl'; import { fetchFaculties, fetchAcademicYears, fetchStudyCycle } from '../Lookups/util';
import { DEFAULT_CHART_COLORS as colors, center } from './util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class GraduatedStudentsPerStudyCycle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            faculties: [],
            faculty: '',
            academicYears: [],
            academicYear: '',
            data: [],
            studyCycles: [],

            loading: true,
            showChart: false
        };

        this.fetchFacultiesAcademicYearsAndStudyCycle = this.fetchFacultiesAcademicYearsAndStudyCycle.bind(this);
        this.generateChartData = this.generateChartData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getFacultyName = this.getFacultyName.bind(this);
        this.getAcademicYearName = this.getAcademicYearName.bind(this);
        this.getStudyCycleName = this.getStudyCycleName.bind(this);
    }


    componentDidMount() {
        this.fetchFacultiesAcademicYearsAndStudyCycle();
    }

    getFacultyName() {
        const { faculties, faculty } = this.state;
        const selected = faculties.find(el => el.id === faculty);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getAcademicYearName() {
        const { academicYear, academicYears } = this.state;
        const selected = academicYears.find(el => el.id === academicYear);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getStudyCycleName(id) {
        const { studyCycles } = this.state;
        const selected = studyCycles.find(el => el.id === id);
        if (selected && selected.displayName) return selected.displayName;
        return '';
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    fetchFacultiesAcademicYearsAndStudyCycle() {
        axios.all([fetchFaculties(), fetchAcademicYears(), fetchStudyCycle()])
            .then(axios.spread((facultiesRes, academicYearsRes, studyCyclesRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const studyCycles = studyCyclesRes.data.map(el => ({ ...el, value: el.id, name: el.name }));
                this.setState({
                    academicYears, faculties, studyCycles, loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch faculties or academic years or study cycle');
            });
    }


    generateChartData() {
        const { faculty, academicYear } = this.state;
        axios.get(`/statistics/graduated-per-study-cycle/?facultyId=${faculty}&academicYearId=${academicYear}`)
            .then(res => {
                const data = res.data.map(el => ({ ...el, studyCycle: this.getStudyCycleName(el.studyCycleId), 'Broj studenata': el.numberOfStudents }));
                this.setState({ data, showChart: true });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });
    }


    render() {
        const { data } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">{<FormattedMessage id="statistics.statistic" />}</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            {<FormattedMessage id="statistics.selectFacultyAndAcademicYear" />}
                        </Header>
                    </Segment>
                    <Segment>

                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.faculty" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectFaculty" />}
                                        value={this.state.faculty}
                                        onChange={this.handleInputChange}
                                        name="faculty"
                                        options={this.state.faculties}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.academicYear" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectAcademicYear" />}
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                                <Form.Button label=" " color="blue" basic="true" onClick={this.generateChartData}>{<FormattedMessage id="common.show" />}</Form.Button>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>

                {this.state.showChart && <Segment.Group raised>
                    <Segment raised >
                        <Header as="h2">
                            {this.getFacultyName()}
                        </Header>
                        <Header as="h3">   {<FormattedMessage id="statistics.headerNumberGraduatedStudentsPerStudyCycles" />}  {this.getAcademicYearName()} {<FormattedMessage id="statistics.headerAcademicYear" />}</Header>

                    </Segment>
                    {data.length ? <Segment>
                        <br />
                        <BarChart
                            style={center}
                            width={930}
                            height={250}
                            data={data}
                            margin={{ top: 20 }}
                        >
                            <XAxis dataKey="studyCycle" />
                            <YAxis />
                            <Tooltip />
                            <Bar
                                dataKey="Broj studenata"
                                fill="#0C1669"
                                isAnimationActive
                            >
                                {
                                    data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={colors[index]} />
                                    ))
                                }
                                <LabelList dataKey="Broj studenata" position="top" fill="#001942" />
                            </Bar>

                        </BarChart>

                        <br />
                    </Segment>
                        : <Segment>
        Nema podataka na ovom fakultetu za odabranu akademsku godinu.
                        </Segment>}
                </Segment.Group>}
            </div>
        );
    }
}

export default GraduatedStudentsPerStudyCycle;



// WEBPACK FOOTER //
// ./src/views/Statistics/GraduatedStudentsPerStudyCycle.js